import type { ReactNode } from 'react';

import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';
import type { I18nFn } from 'i18n/types/I18nFn';

type Args = {
  i18n: I18nFn;
  orgUrl: string | undefined;
  orgPublishedJobsCount: number;
};

export function getUnpublishedJobPageSeeMoreText({
  i18n,
  orgUrl,
  orgPublishedJobsCount,
}: Args): ReactNode {
  if (!orgUrl) {
    return i18n('Search below for a job title that interests you.');
  }

  const link = (
    <StyledVersionedRouterLink
      to={orgUrl}
      data-qa-id="view-job-page-unpublished-view-organization-opportunities"
    />
  );

  if (orgPublishedJobsCount > 0) {
    return i18n(
      'You can see more {{link}}jobs by this organization{{/link}}, or search below',
      { link },
    );
  }

  return i18n(
    'You can learn more about {{link}}the organization that posted this listing{{/link}}, or search below',
    { link },
  );
}
